import {
  MonitorPriority,
  monitorPriorities,
} from "@p0security/shared/types/assessment/monitor";
import { Space, Typography } from "antd";
import { priorityColor } from "components/Assessment/utils/monitor";
import { VerticalDiv } from "components/divs";
import { compact } from "lodash";
import { useMemo } from "react";
import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";
import { colors } from "styles/variables";

import { ColorCodeIndicator } from "../common/ColorCodeIndicator";

const { Text } = Typography;

export const FindingGraphTooltip = ({
  active,
  payload,
  label,
}: TooltipProps<ValueType, NameType>) => {
  const data = useMemo(
    () =>
      compact(
        monitorPriorities.map((priority) =>
          payload?.find((d) => d.dataKey === priority)
        )
      ),
    [payload]
  );

  return active && payload && data.some((d) => d.value) ? (
    <VerticalDiv
      style={{
        backgroundColor: colors.neutral["00"],
        padding: "10px",
        gap: "4px",
      }}
    >
      <Text>{label}</Text>
      {data.map(
        (p) =>
          p && (
            <Space size="small" key={p.name}>
              <ColorCodeIndicator
                color={
                  p?.dataKey
                    ? priorityColor[p.dataKey as MonitorPriority].color
                    : ""
                }
                style={{ height: "1em" }}
              />
              <Text key={p.name}>{`${p.name}: ${p.value}`}</Text>
            </Space>
          )
      )}
    </VerticalDiv>
  ) : null;
};
